import { render, staticRenderFns } from "./EventTabOverview.vue?vue&type=template&id=579be82e&scoped=true&"
import script from "./EventTabOverview.vue?vue&type=script&lang=js&"
export * from "./EventTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./EventTabOverview.vue?vue&type=style&index=0&id=579be82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579be82e",
  null
  
)

export default component.exports